module.exports = __webpack_public_path__ + "static/media/truck2.2cf53364.jpg";